// Motion tokens and utilities for consistent animations
export const MotionTokens = {
  durations: {
    fast: 0.2,
    normal: 0.35,
    slow: 0.5,
    slower: 0.8
  },
  
  easings: {
    easeOut: [0.16, 1, 0.3, 1],
    easeInOut: [0.4, 0, 0.2, 1],
    spring: { type: "spring", stiffness: 220, damping: 28 }
  },
  
  zIndices: {
    dropdown: 50,
    modal: 100,
    notification: 200,
    whatsapp: 300
  }
};

// Global reveal animation pattern
export const revealVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: {
      duration: MotionTokens.durations.slow,
      ease: MotionTokens.easings.easeOut
    }
  }
};

// Stagger children animation
export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};

// Button hover animations
export const buttonVariants = {
  initial: { scale: 1 },
  hover: { 
    scale: 1.03,
    transition: { duration: MotionTokens.durations.fast }
  },
  tap: { 
    scale: 0.98,
    transition: { duration: MotionTokens.durations.fast }
  }
};

// Card hover animations
export const cardVariants = {
  initial: { y: 0 },
  hover: { 
    y: -6,
    transition: { duration: MotionTokens.durations.normal }
  }
};

// Check if user prefers reduced motion
export const shouldReduceMotion = () => {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

// Reduced motion variants
export const getReducedMotionVariants = (normalVariants) => {
  if (shouldReduceMotion()) {
    return {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.1 } }
    };
  }
  return normalVariants;
};

// Mobile-safe animation configurations
export const getMobileVariants = (normalVariants) => {
  const isMobile = window.innerWidth < 768;
  
  if (isMobile) {
    return {
      ...normalVariants,
      visible: {
        ...normalVariants.visible,
        y: 12, // Reduced distance
        transition: {
          ...normalVariants.visible.transition,
          duration: MotionTokens.durations.normal // Faster on mobile
        }
      }
    };
  }
  
  return normalVariants;
};